import { createReducer } from '@reduxjs/toolkit';

import {
  setActiveTab,
  setCurrentFeedData,
  setDefaultFeedData,
  setHomepageBackgroundPosition,
  setIsLoading,
  setOpenTabScrollPosition,
  setVisitedByBackButton,
} from 'store/actions/homepageActions';

const INITIAL_STATE = {
  activeTab: null,
  currentSearchLandingFeedData: null,
  homepageScrollPosition: 0,
  isLoading: false,
  openTabScrollPosition: 0,
  visitedByBackButton: false,
};

const homepageTabReducer = createReducer(INITIAL_STATE, (builder) => {
  builder.addCase(setActiveTab, (state, action) => {
    state.activeTab = action.payload;
  });
  builder.addCase(setCurrentFeedData, (state, action) => {
    if (
      action?.payload?.constructorResponse &&
      state.currentSearchLandingFeedData &&
      typeof action?.payload?.index === 'number'
    ) {
      const currentState = { ...state.currentSearchLandingFeedData };
      const sections = [...currentState?.sections];
      sections[action?.payload?.index].constructorResponse = action?.payload?.constructorResponse;
      delete currentState?.sections;
      const updatedState = { ...currentState, sections };
      state.currentSearchLandingFeedData = updatedState;
    } else if (
      action?.payload?.subsections &&
      state.currentSearchLandingFeedData &&
      typeof action?.payload?.index === 'number'
    ) {
      const currentState = { ...state.currentSearchLandingFeedData };
      const sections = [...currentState?.sections];
      sections[action?.payload?.index].subsections = action?.payload?.subsections;
      delete currentState?.sections;
      const updatedState = { ...currentState, sections };
      state.currentSearchLandingFeedData = updatedState;
    }
  });
  builder.addCase(setDefaultFeedData, (state, action) => {
    if (action?.payload?.uuid || action?.payload?.id) {
      state.currentSearchLandingFeedData = action.payload;
    }
  });
  builder.addCase(setHomepageBackgroundPosition, (state, action) => {
    state.openTabScrollPosition = action.payload;
  });
  builder.addCase(setIsLoading, (state, action) => {
    state.isLoading = action.payload;
  });
  builder.addCase(setOpenTabScrollPosition, (state, action) => {
    state.openTabScrollPosition = action.payload;
  });
  builder.addCase(setVisitedByBackButton, (state, action) => {
    state.visitedByBackButton = action.payload;
  });
});

export default homepageTabReducer;
